import { Component, Input } from '@angular/core';
import { EoBaseViewComponent } from '../eo-base-view/eo-base-view.component';
import { IViewComponent } from '../eo-base-view/i-view-component';
import { formatCurrency } from '@angular/common';
import { EoViewComponentTypeEnum } from '../eo-base-view/eo-view-component-type-enum';

@Component({
  selector: 'eo-currency',
  templateUrl: './eo-currency.component.html',
  styleUrl: './eo-currency.component.scss',
})
export class EoCurrencyComponent
  extends EoBaseViewComponent
  implements IViewComponent
{
  @Input() decimalDigits: number = 2;
  @Input() currencyFormat: string = 'EUR';

  getFormattedValue(): string {
    const parsed: number = parseFloat((this.value ?? '').toString());
    const amount: number | undefined = isNaN(parsed) ? undefined : parsed;
    if (!amount) return '-';

    try {
      const value = amount.toLocaleString('el-GR', {
        maximumFractionDigits: this.decimalDigits,
        style: 'currency',
        currency: this.currencyFormat,
      });

      return value;
    } catch (err) {
      if (err instanceof RangeError) {
        console.error(`Invalid range error: ${err.message}`);
        return '-';
      } else {
        console.error(err);
        throw err;
      }
    }
  }

  getViewComponentType(): EoViewComponentTypeEnum{
    return EoViewComponentTypeEnum.CURRENCY;
  }
}
